<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="players" stripe border size="small" :max-height="visualAreaHeight"
                  style="width: 100%; margin-top: 1rem">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="school_name" label="学校名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="team_name" label="队伍名称" align="center" min-width="200"></el-table-column>
            <el-table-column prop="player_present.male_teachers_number" label="男教师人数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.female_teachers_number" label="女教师人数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.teachers_number" label="教师总数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.male_students_number" label="男学生人数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.female_students_number" label="女学生人数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.students_number" label="学生总数" align="center"
                             min-width="90"></el-table-column>
            <el-table-column prop="player_present.total" label="总人数" align="center"
                             min-width="90"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {handlePlayers} from '../../../../../utils/data-handler';
    import _ from 'lodash';

    export default {
        name: '',
        data () {
            return {
                players: [],
                requesting: false
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminPlayerInformationOverviewVisualAreaHeight'];
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadPlayersByCompetitionId(id);
                }
            }
        },
        methods: {
            loadPlayersByCompetitionId (id) {
                this.$normalRequest('player/loadPlayersByCompetitionId', {
                    competition_id: id
                }, false, false, this, 'requesting').then(data => {
                    this.players = handlePlayers(_.filter(data, item => item.player_present !== null));
                });
            }
        }
    };
</script>
